import { Grid, MenuItem, Paper, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Header from 'components/Header'
import StudentSearch from 'components/StudentSearch'
import dayjs from 'dayjs'
import { search as searchStudentAttendance } from 'store/attendance/attendance'
import DateRangePicker from 'components/DateRangePicker/DateRangePicker'

export default function StudentSearchBar({ student, setStudent, setDateRange, dateRange }) {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { markingPeriods } = useSelector(state => state.session.academicYear)
  const sessionAcademicYear = useSelector(state => state.session.academicYear)
  const [filterBy, setFilterBy] = useState('custom')

  const handleFilterChangeWithDate = value => {
    if (value === 'custom') {
      setDateRange([dayjs().startOf('week').add(1, 'day'), dayjs()])
    } else if (value === 'fullYear') {
      setDateRange([markingPeriods[0]?.startDate, markingPeriods[markingPeriods.length - 1]?.endDate])
    } else {
      const mp = markingPeriods.find(mp => mp.name === value)
      if (mp) setDateRange([mp.startDate, mp.endDate])
    }
    setFilterBy(value)
  }

  useEffect(() => {
    dateRange[0] && dateRange[1] && fetchAttendance()
  }, [student, dateRange])

  function fetchAttendance() {
    if (dateRange && student?.schoolEnrollmentId) {
      dispatch(
        searchStudentAttendance({
          offset: 0,
          limit: 10,
          date: dayjs(dateRange[0]).format('YYYY-MM-DD'),
          endDate: dayjs(dateRange[1]).format('YYYY-MM-DD'),
          schoolEnrollmentId: student.schoolEnrollmentId,
        }),
      )
    }
  }

  return (
    <Paper sx={{ width: '100%', px: 2, pb: 2, mb: 2 }}>
      <div style={{ marginLeft: -10 }}>
        <Header title={t('Student Attendance')} small />
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12} md={5}>
          <StudentSearch
            label={t('Student')}
            value={student}
            onSelect={setStudent}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            select
            fullWidth
            size="small"
            color="primary"
            label={t('Filter By')}
            value={filterBy}
            onChange={event => handleFilterChangeWithDate(event.target.value)}
          >
            <MenuItem value={'custom'}>{t('Custom Dates')}</MenuItem>
            <MenuItem value={'fullYear'}>{t('Full Year')}</MenuItem>
            {markingPeriods?.map(mp => (
              <MenuItem key={mp.name} value={mp.name}>{mp.name}</MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={4}>
          <DateRangePicker
            startDate={dateRange[0]}
            endDate={dateRange[1]}
            setDateRange={setDateRange}
            disabled={filterBy !== 'custom'}
            minDate={sessionAcademicYear.startDate}
            maxDate={sessionAcademicYear.endDate}
          />
        </Grid>
      </Grid>
    </Paper>
  )
}
